import { flexRender, type Table as TanstackTable } from '@tanstack/react-table';
import { defineMessages, useIntl } from 'react-intl';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../Table/Table';

type DataTableProps<TData> = {
  table: TanstackTable<TData>;
};

const messages = defineMessages({
  noResults: {
    defaultMessage: 'No results',
    id: 'jHJmjf',
  },
});

export function DataTable<TData>({ table }: DataTableProps<TData>) {
  const { formatMessage } = useIntl();

  return (
    <Table isRounded hasBorder style={{ width: table.getCenterTotalSize() }}>
      <TableHeader>
        {table.getHeaderGroups().map((headerGroup) => (
          <TableRow key={headerGroup.id}>
            {headerGroup.headers.map((header) => {
              return (
                <TableHead
                  key={header.id}
                  style={{
                    width: header.getSize() || 'auto',
                  }}
                >
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                </TableHead>
              );
            })}
          </TableRow>
        ))}
      </TableHeader>
      <TableBody>
        {table.getRowModel().rows.length ? (
          table.getRowModel().rows.map((row) => (
            <TableRow
              key={row.id}
              data-state={row.getIsSelected() && 'selected'}
            >
              {row.getVisibleCells().map((cell) => (
                <TableCell
                  key={cell.id}
                  style={{ width: cell.column.getSize() || 'auto' }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </TableCell>
              ))}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={table.getAllColumns().length}
              className="h-24 text-center"
            >
              {formatMessage(messages.noResults)}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
